<template>
  <v-dialog
    v-model="sendTypeDialog"
    persistent
    max-width="500px">
    <v-card class="pb-1">
      <v-card-title class="px-3 pt-3">
        <h4 class="font-weight-bold">テンプレートの送信</h4>
      </v-card-title>
      <v-divider class="my-1 mx-3"></v-divider>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex>
              <h3>テンプレート送信方法を選択してください!</h3>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="border-1" flat :disabled="loading" @click.native="modifyTemplate">修正後の送信</v-btn>
        <v-btn class="registration" flat :loading="loading" :disabled="loading" @click.native="sendImmediately">すぐに
          送信
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import helper from 'util/helpers'
import eventBus from '@/event_bus'
import {mapGetters} from 'vuex'

export default {
  props: ['type', 'active', 'setMessage', 'sendMessage', 'sendLoading', 'chatRoomId'],
  computed: {
    ...mapGetters([
      'displayingChatRoomId',
      'activeChatRoomList',
      'transferredChatRoomList'
    ])
  },
  data () {
    return {
      loading: false,
      templateAnswer: '',
      sendTypeDialog: false
    }
  },
  created () {
    eventBus.$on(`send-template-${this.displayingChatRoomId}`, templateInfo => {
      if (this.sendLoading) {
        return this.$alertMsg('送信中はナレッジの使用が制限されます。')
      }
      if (this.active && (helper.findByChatRoomId(this.activeChatRoomList, this.displayingChatRoomId) !== undefined || helper.findByChatRoomId(this.transferredChatRoomList, this.displayingChatRoomId) !== undefined)) {
        this.templateAnswer = templateInfo.templateAnswer
        if (templateInfo.type === this.type) {
          // this.openSendTemplateDialog()
          this.$eventBus.$emit('DialogPopup', {
            useDialog: true,
            messageHTML: '<dl class="txt"><dt>ナレッジを送信する方法を選択してください。</dd></dl>',
            getBtnCount: 2,
            getLeftBtnName: '編集後に送信',
            getBtnName: 'すぐに送信',
            closeBox: true,
            getLeftBtnEvent: this.modifyTemplate,
            getButtonEvent: this.sendImmediately
          })
        } else {
          this.$alertMsg('正しいナレッジを選択してください。')
        }
      }
    })
  },
  destroyed () {
    eventBus.$off(`send-template-${this.chatRoomId}`)
  },
  methods: {
    openSendTemplateDialog () {
      this.sendTypeDialog = true
    },
    closeSendTemplateDialog () {
      this.sendTypeDialog = false
    },
    sendImmediately () {
      this.setMessage(this.templateAnswer)
      this.sendMessage()
      // this.closeSendTemplateDialog()
    },
    modifyTemplate () {
      this.setMessage(this.templateAnswer)
      // this.closeSendTemplateDialog()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/operation/fragments/right/send_template_dialog.vue